import { createApiQueryClient, createApiQueryPersister } from '@sequencehq/api'
import { HOURS, MINUTES } from '@sequencehq/utils/dates'

export const apiQueryClient = createApiQueryClient({
  defaultOptions: {
    queries: {
      gcTime: 5 * MINUTES
    }
  }
})

/**
 * Customer endpoints opt in to IndexedDB persistence by setting `persist: true`
 * in their definition. The persister picks them up via the shared
 * `ApiQueryProvider` filter. List/cursor-heavy endpoints intentionally do not
 * opt in — their cache footprint is too volatile to persist usefully.
 */
export const apiQueryPersister = createApiQueryPersister()

export const PERSISTED_CACHE_MAX_AGE = 24 * HOURS
